import { ReactElement, ReactNode } from 'react';

interface ButtonListProps {
  children: ReactNode;
  className?: string;
}

export default function ButtonList({ children, className = '' }: ButtonListProps): ReactElement {
  return (
    <div
      className={`cr-mb-4 cr-flex cr-w-full cr-flex-row cr-gap-1 cr-font-main cr-text-base cr-text-lg ${className}`}
    >
      {children}
    </div>
  );
}
